function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _defaultSchema_attributes, _defaultSchema_attributes1;
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkGfm from "remark-gfm";
var _defaultSchema_attributes_, _defaultSchema_attributes_img;
/**
 * Renders markdown safely by pairing rehypeRaw with rehypeSanitize.
 * rehypeRaw must run first (to parse embedded HTML into hast nodes),
 * then rehypeSanitize strips any disallowed tags/attrs.
 *
 * defaultSchema is extended with:
 *   - "*": adds "className" — required so custom class-based renderers and
 *     syntax highlighters can pass classNames through without being stripped.
 *   - img: adds "alt" — src is already in defaultSchema.
 */ export var sanitizeSchema = _object_spread_props(_object_spread({}, defaultSchema), {
    attributes: _object_spread_props(_object_spread({}, defaultSchema.attributes), {
        "*": _to_consumable_array((_defaultSchema_attributes_ = (_defaultSchema_attributes = defaultSchema.attributes) === null || _defaultSchema_attributes === void 0 ? void 0 : _defaultSchema_attributes["*"]) !== null && _defaultSchema_attributes_ !== void 0 ? _defaultSchema_attributes_ : []).concat([
            "className"
        ]),
        img: _to_consumable_array((_defaultSchema_attributes_img = (_defaultSchema_attributes1 = defaultSchema.attributes) === null || _defaultSchema_attributes1 === void 0 ? void 0 : _defaultSchema_attributes1.img) !== null && _defaultSchema_attributes_img !== void 0 ? _defaultSchema_attributes_img : []).concat([
            "alt"
        ])
    })
});
var BASE_REHYPE_PLUGINS = [
    rehypeRaw,
    [
        rehypeSanitize,
        sanitizeSchema
    ]
];
var BASE_REMARK_PLUGINS = [
    remarkGfm
];
export var SafeMarkdown = function(param) {
    var children = param.children, className = param.className, components = param.components, remarkPlugins = param.remarkPlugins;
    var mergedRemarkPlugins = useMemo(function() {
        return remarkPlugins ? _to_consumable_array(BASE_REMARK_PLUGINS).concat(_to_consumable_array(remarkPlugins)) : BASE_REMARK_PLUGINS;
    }, [
        remarkPlugins
    ]);
    return /*#__PURE__*/ _jsx(ReactMarkdown, {
        className: className,
        components: components,
        rehypePlugins: BASE_REHYPE_PLUGINS,
        remarkPlugins: mergedRemarkPlugins,
        children: children
    });
};

//# sourceMappingURL=SafeMarkdown.js.map